__turbopack_context__.v({
  "bgCard1": "CardModal-module-scss-module__ppmeAG__bgCard1",
  "bgCard2": "CardModal-module-scss-module__ppmeAG__bgCard2",
  "bgCard3": "CardModal-module-scss-module__ppmeAG__bgCard3",
  "cardImage": "CardModal-module-scss-module__ppmeAG__cardImage",
  "cardTop": "CardModal-module-scss-module__ppmeAG__cardTop",
  "desc": "CardModal-module-scss-module__ppmeAG__desc",
  "statusPic": "CardModal-module-scss-module__ppmeAG__statusPic",
});
